import ApiClient from '../../../helpers/apiClient';
import { startSubmit } from 'redux-form';

export const FETCH_TECHNICIANS_REQUEST = 'FETCH_TECHNICIANS_REQUEST';
export const FETCH_TECHNICIANS_SUCCESS = 'FETCH_TECHNICIANS_SUCCESS';
export const FETCH_TECHNICIANS_ERROR = 'FETCH_TECHNICIANS_ERROR';

export const FETCH_TECHNICIAN_OPTIONS_REQUEST = 'FETCH_TECHNICIAN_OPTIONS_REQUEST';
export const FETCH_TECHNICIAN_OPTIONS_SUCCESS = 'FETCH_TECHNICIAN_OPTIONS_SUCCESS';
export const FETCH_TECHNICIAN_OPTIONS_ERROR = 'FETCH_TECHNICIAN_OPTIONS_ERROR';

export const FETCH_TECHNICIAN_LEADER_OPTIONS_REQUEST = 'FETCH_TECHNICIAN_LEADER_OPTIONS_REQUEST';
export const FETCH_TECHNICIAN_LEADER_OPTIONS_SUCCESS = 'FETCH_TECHNICIAN_LEADER_OPTIONS_SUCCESS';
export const FETCH_TECHNICIAN_LEADER_OPTIONS_ERROR = 'FETCH_TECHNICIAN_LEADER_OPTIONS_ERROR';

export const FETCH_TECHNICIAN_GROUP_OPTIONS_REQUEST = 'FETCH_TECHNICIAN_GROUP_OPTIONS_REQUEST';
export const FETCH_TECHNICIAN_GROUP_OPTIONS_SUCCESS = 'FETCH_TECHNICIAN_GROUP_OPTIONS_SUCCESS';
export const FETCH_TECHNICIAN_GROUP_OPTIONS_ERROR = 'FETCH_TECHNICIAN_GROUP_OPTIONS_ERROR';

export const GET_TECHNICIAN_HIERARCHY_DATA_REQUEST =
    'GET_TECHNICIAN_HIERARCHY_DATA_REQUEST';
export const GET_TECHNICIAN_HIERARCHY_DATA_SUCCESS =
    'GET_TECHNICIAN_HIERARCHY_DATA_SUCCESS';
export const GET_TECHNICIAN_HIERARCHY_DATA_ERROR = 'GET_TECHNICIAN_HIERARCHY_DATA_ERROR';

export const GET_TECHNICIAN_DETAIL_REQUEST = 'GET_TECHNICIAN_DETAIL_REQUEST';
export const GET_TECHNICIAN_DETAIL_SUCCESS = 'GET_TECHNICIAN_DETAIL_SUCCESS';
export const GET_TECHNICIAN_DETAIL_ERROR = 'GET_TECHNICIAN_DETAIL_ERROR';

export const UPDATE_TECHNICIAN_REQUEST = 'UPDATE_TECHNICIAN_REQUEST';
export const UPDATE_TECHNICIAN_SUCCESS = 'UPDATE_TECHNICIAN_SUCCESS';
export const UPDATE_TECHNICIAN_ERROR = 'UPDATE_TECHNICIAN_ERROR';

export const DELETE_TECHNICIAN_REQUEST = 'DELETE_TECHNICIAN_REQUEST';
export const DELETE_TECHNICIAN_SUCCESS = 'DELETE_TECHNICIAN_SUCCESS';
export const DELETE_TECHNICIAN_ERROR = 'DELETE_TECHNICIAN_ERROR';

export const DELETE_TECHNICIAN_GROUP_REQUEST = 'DELETE_TECHNICIAN_GROUP_REQUEST';
export const DELETE_TECHNICIAN_GROUP_SUCCESS = 'DELETE_TECHNICIAN_GROUP_SUCCESS';
export const DELETE_TECHNICIAN_GROUP_ERROR = 'DELETE_TECHNICIAN_GROUP_ERROR';

export const CREATE_TECHNICIAN_LEVEL_REQUEST = 'CREATE_TECHNICIAN_LEVEL_REQUEST';
export const CREATE_TECHNICIAN_LEVEL_SUCCESS = 'CREATE_TECHNICIAN_LEVEL_SUCCESS';
export const CREATE_TECHNICIAN_LEVEL_ERROR = 'CREATE_TECHNICIAN_LEVEL_ERROR';

export const GET_TECHNICIAN_LEVEL_DETAIL_REQUEST = 'GET_TECHNICIAN_LEVEL_DETAIL_REQUEST';
export const GET_TECHNICIAN_LEVEL_DETAIL_SUCCESS = 'GET_TECHNICIAN_LEVEL_DETAIL_SUCCESS';
export const GET_TECHNICIAN_LEVEL_DETAIL_ERROR = 'GET_TECHNICIAN_LEVEL_DETAIL_ERROR';


export const DELETE_TECHNICIAN_LEVEL_REQUEST = 'DELETE_TECHNICIAN_LEVEL_REQUEST';
export const DELETE_TECHNICIAN_LEVEL_SUCCESS = 'DELETE_TECHNICIAN_LEVEL_SUCCESS';
export const DELETE_TECHNICIAN_LEVEL_ERROR = 'DELETE_TECHNICIAN_LEVEL_ERROR';

export const FETCH_TECHNICIAN_LEVEL_REQUEST = 'FETCH_TECHNICIAN_LEVEL_REQUEST';
export const FETCH_TECHNICIAN_LEVEL_SUCCESS = 'FETCH_TECHNICIAN_LEVEL_SUCCESS';
export const FETCH_TECHNICIAN_LEVEL_ERROR = 'FETCH_TECHNICIAN_LEVEL_ERROR';

export const FETCH_TECHNICIAN_LEVEL_OPTIONS_REQUEST = "FETCH_TECHNICIAN_LEVEL_OPTIONS_REQUEST";
export const FETCH_TECHNICIAN_LEVEL_OPTIONS_SUCCESS = "FETCH_TECHNICIAN_LEVEL_OPTIONS_SUCCESS";
export const FETCH_TECHNICIAN_LEVEL_OPTIONS_ERROR = "FETCH_TECHNICIAN_LEVEL_OPTIONS_ERROR";

export const FETCH_TECHNICIAN_COMMISSION_REQUEST = "FETCH_TECHNICIAN_COMMISSION_REQUEST";
export const FETCH_TECHNICIAN_COMMISSION_SUCCESS = "FETCH_TECHNICIAN_COMMISSION_SUCCESS";
export const FETCH_TECHNICIAN_COMMISSION_ERROR = "FETCH_TECHNICIAN_COMMISSION_ERROR";

export const FETCH_TECHNICIAN_COMMISSION_HISTORY_REQUEST = "FETCH_TECHNICIAN_COMMISSION_HISTORY_REQUEST";
export const FETCH_TECHNICIAN_COMMISSION_HISTORY_SUCCESS = "FETCH_TECHNICIAN_COMMISSION_HISTORY_SUCCESS";
export const FETCH_TECHNICIAN_COMMISSION_HISTORY_ERROR = "FETCH_TECHNICIAN_COMMISSION_HISTORY_ERROR";

export const GET_TECHNICIAN_COMMISSION_DETAIL_REQUEST = "GET_TECHNICIAN_COMMISSION_DETAIL_REQUEST";
export const GET_TECHNICIAN_COMMISSION_DETAIL_SUCCESS = "GET_TECHNICIAN_COMMISSION_DETAIL_SUCCESS";
export const GET_TECHNICIAN_COMMISSION_DETAIL_ERROR = "GET_TECHNICIAN_COMMISSION_DETAIL_ERROR";

export const UPDATE_TECHNICIAN_COMMISSION_REQUEST = 'UPDATE_TECHNICIAN_COMMISSION_REQUEST';
export const UPDATE_TECHNICIAN_COMMISSION_SUCCESS = 'UPDATE_TECHNICIAN_COMMISSION_SUCCESS';
export const UPDATE_TECHNICIAN_COMMISSION_ERROR = 'UPDATE_TECHNICIAN_COMMISSION_ERROR';

export const GENERATE_TECHNICIAN_COMMISSION_PDF_REQUEST = 'GENERATE_TECHNICIAN_COMMISSION_PDF_REQUEST';
export const GENERATE_TECHNICIAN_COMMISSION_PDF_SUCCESS = 'GENERATE_TECHNICIAN_COMMISSION_PDF_SUCCESS';
export const GENERATE_TECHNICIAN_COMMISSION_PDF_ERROR = 'GENERATE_TECHNICIAN_COMMISSION_PDF_ERROR';

export const GET_TECHNICIAN_LOCATION_DETAIL_REQUEST =
    'GET_TECHNICIAN_LOCATION_DETAIL_REQUEST';
export const GET_TECHNICIAN_LOCATION_DETAIL_SUCCESS =
    'GET_TECHNICIAN_LOCATION_DETAIL_SUCCESS';
export const GET_TECHNICIAN_LOCATION_DETAIL_ERROR =
    'GET_TECHNICIAN_LOCATION_DETAIL_ERROR';

export const UPDATE_TECHNICIAN_LOCATION_REQUEST = 'UPDATE_TECHNICIAN_LOCATION_REQUEST';
export const UPDATE_TECHNICIAN_LOCATION_SUCCESS = 'UPDATE_TECHNICIAN_LOCATION_SUCCESS';
export const UPDATE_TECHNICIAN_LOCATION_ERROR = 'UPDATE_TECHNICIAN_LOCATION_ERROR';

//service group
export const fetchTechnicianGroups = data => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [FETCH_TECHNICIANS_REQUEST, FETCH_TECHNICIANS_SUCCESS, FETCH_TECHNICIANS_ERROR],
            callAPI: () => ApiClient.post('service/TechnicianGroup/Search', data),
            payload: { data },
        }),
    );
};

export const generateTechnicianCommissionPdf = data => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [
                GENERATE_TECHNICIAN_COMMISSION_PDF_REQUEST,
                GENERATE_TECHNICIAN_COMMISSION_PDF_SUCCESS,
                GENERATE_TECHNICIAN_COMMISSION_PDF_ERROR
            ],
            callAPI: () => ApiClient.post(`service/TechnicianCommissions/CreateTechnicianCommissionPDF`, data),
            payload: { data },
        }),
    );
};


export const generateTechnicianCommissionDetailPdf = data => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [
                GENERATE_TECHNICIAN_COMMISSION_PDF_REQUEST,
                GENERATE_TECHNICIAN_COMMISSION_PDF_SUCCESS,
                GENERATE_TECHNICIAN_COMMISSION_PDF_ERROR
            ],
            callAPI: () => ApiClient.post(`service/TechnicianCommissions/CreateTechnicianCommissionDetailsPDF`, data),
            payload: { data },
        }),
    );
};

export const getTechnicianGroupDetail = id => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [
                GET_TECHNICIAN_DETAIL_REQUEST,
                GET_TECHNICIAN_DETAIL_SUCCESS,
                GET_TECHNICIAN_DETAIL_ERROR,
            ],
            callAPI: () => ApiClient.get(`service/TechnicianGroup/GetDetail/${id}`),
            payload: { data: { id } },
        }),
    );
};

export const updateTechnicianGroup = (id, data, formId) => dispatch => {
    console.log(id);
    console.log(data);

    return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
        dispatch({
            types: [UPDATE_TECHNICIAN_REQUEST, UPDATE_TECHNICIAN_SUCCESS, UPDATE_TECHNICIAN_ERROR],
            callAPI: () => ApiClient.put(`service/TechnicianGroup/${id}`, data),
            payload: { data: { id, ...data }, formId },
        }),
    );
};

export const deleteTechnicianGroup = id => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [DELETE_TECHNICIAN_GROUP_REQUEST, DELETE_TECHNICIAN_GROUP_SUCCESS, DELETE_TECHNICIAN_GROUP_ERROR],
            callAPI: () => ApiClient.delete(`service/TechnicianGroup/${id}`),
            payload: { data: { id } },
        }),
    );
};

export const createTechnicianGroup = (data, formId) => dispatch => {
    return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
        dispatch({
            types: [CREATE_TECHNICIAN_LEVEL_REQUEST, CREATE_TECHNICIAN_LEVEL_SUCCESS, CREATE_TECHNICIAN_LEVEL_ERROR],
            callAPI: () => ApiClient.post('service/TechnicianGroup', data),
            payload: { data, formId },
        }),
    );
};

export const fetchTechnicians = data => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [FETCH_TECHNICIANS_REQUEST, FETCH_TECHNICIANS_SUCCESS, FETCH_TECHNICIANS_ERROR],
            callAPI: () => ApiClient.post('service/Technicians/Search', data),
            payload: { data },
        }),
    );
};

export const fetchTechnicianLocations = data => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [FETCH_TECHNICIANS_REQUEST, FETCH_TECHNICIANS_SUCCESS, FETCH_TECHNICIANS_ERROR],
            callAPI: () => ApiClient.post('service/TechnicianLocation/Search', data),
            payload: { data },
        }),
    );
};

export const getTechnicianLocationDetail = id => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [GET_TECHNICIAN_LOCATION_DETAIL_REQUEST, GET_TECHNICIAN_LOCATION_DETAIL_SUCCESS, GET_TECHNICIAN_LOCATION_DETAIL_ERROR],
            callAPI: () => ApiClient.get(`service/TechnicianLocation/GetDetail/${id}`),
            payload: { data: { id } },
        }),
    );
};

export const updateTechnicianLocation = (id, data, formId) => dispatch => {
    return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
        dispatch({
            types: [UPDATE_TECHNICIAN_LOCATION_REQUEST, UPDATE_TECHNICIAN_LOCATION_SUCCESS, UPDATE_TECHNICIAN_LOCATION_ERROR],
            callAPI: () => ApiClient.put(`service/TechnicianLocation/${id}`, data),
            payload: { data: { ...data, id }, formId },
        }),
    );
};

export const fetchTechnicianLeaderOptions = (customerId) => dispatch => {
    const validCustomerId = customerId ?? "";
    return Promise.resolve().then(() =>
        dispatch({
            types: [
                FETCH_TECHNICIAN_LEADER_OPTIONS_REQUEST,
                FETCH_TECHNICIAN_LEADER_OPTIONS_SUCCESS,
                FETCH_TECHNICIAN_LEADER_OPTIONS_ERROR,
            ],
            callAPI: () => ApiClient.get(`service/Technicians/GetLeaderSelectList?customerId=${validCustomerId}`),
            payload: {},
        }),
    );
};

export const fetchTechnicianOptions = (id) => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [
                FETCH_TECHNICIAN_OPTIONS_REQUEST,
                FETCH_TECHNICIAN_OPTIONS_SUCCESS,
                FETCH_TECHNICIAN_OPTIONS_ERROR,
            ],
            callAPI: () => ApiClient.get(`service/Technicians/GetTechnicianSelectList/${id}`),
            payload: {},
        }),
    );
};

export const fetchTechnicianGroupOptions = () => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [
                FETCH_TECHNICIAN_GROUP_OPTIONS_REQUEST,
                FETCH_TECHNICIAN_GROUP_OPTIONS_SUCCESS,
                FETCH_TECHNICIAN_GROUP_OPTIONS_ERROR,
            ],
            callAPI: () => ApiClient.get('service/TechnicianGroup/GetSelectList'),
            payload: {},
        }),
    );
};

export const getTechnicianHierarchyData = () => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [
                GET_TECHNICIAN_HIERARCHY_DATA_REQUEST,
                GET_TECHNICIAN_HIERARCHY_DATA_SUCCESS,
                GET_TECHNICIAN_HIERARCHY_DATA_ERROR,
            ],
            callAPI: () => ApiClient.get('service/Technicians/GetHierarchyData'),
            payload: {},
        }),
    );
};

export const getTechnicianDetail = id => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [
                GET_TECHNICIAN_DETAIL_REQUEST,
                GET_TECHNICIAN_DETAIL_SUCCESS,
                GET_TECHNICIAN_DETAIL_ERROR,
            ],
            callAPI: () => ApiClient.get(`service/Technicians/GetDetail/${id}`),
            payload: { data: { id } },
        }),
    );
};

export const updateTechnician = (id, data, formId) => dispatch => {
    return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
        dispatch({
            types: [UPDATE_TECHNICIAN_REQUEST, UPDATE_TECHNICIAN_SUCCESS, UPDATE_TECHNICIAN_ERROR],
            callAPI: () => ApiClient.put(`service/Technicians/${id}`, data),
            payload: { data: { id, ...data }, formId },
        }),
    );
};

export const deleteTechnician = id => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [DELETE_TECHNICIAN_REQUEST, DELETE_TECHNICIAN_SUCCESS, DELETE_TECHNICIAN_ERROR],
            callAPI: () => ApiClient.delete(`service/Technicians/${id}`),
            payload: { data: { id } },
        }),
    );
};

export const fetchTechnicianCommission = data => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [FETCH_TECHNICIAN_COMMISSION_REQUEST, FETCH_TECHNICIAN_COMMISSION_SUCCESS, FETCH_TECHNICIAN_COMMISSION_ERROR],
            callAPI: () => ApiClient.post('service/TechnicianCommissions/Search', data),
            payload: { data },
        }),
    );

};

export const updateTechnicianCommission = (id, data, formId) => dispatch => {
    return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
        dispatch({
            types: [UPDATE_TECHNICIAN_COMMISSION_REQUEST, UPDATE_TECHNICIAN_COMMISSION_SUCCESS, UPDATE_TECHNICIAN_COMMISSION_ERROR],
            callAPI: () => ApiClient.put(`service/TechnicianCommissions/Update`, data),
            payload: { data: { id, ...data }, formId },
        }),
    );
};


export const getTechnicianCommissionDetail = data => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [GET_TECHNICIAN_COMMISSION_DETAIL_REQUEST,
                GET_TECHNICIAN_COMMISSION_DETAIL_SUCCESS,
                GET_TECHNICIAN_COMMISSION_DETAIL_ERROR,],
            callAPI: () => ApiClient.post('service/TechnicianCommissions/TechnicianCommissionDetail', data),
            payload: { data },
        }),
    );

};

//Technician Level
export const fetchTechnicianLevel = data => dispatch => {

    return Promise.resolve().then(() =>

        dispatch({

            types: [FETCH_TECHNICIAN_LEVEL_REQUEST, FETCH_TECHNICIAN_LEVEL_SUCCESS, FETCH_TECHNICIAN_LEVEL_ERROR],
            callAPI: () => ApiClient.post('service/TechnicianLevel/Search', data),
            payload: { data },
        }),
    );

};


export const fetchTechnicianLevelOptions = () => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [
                FETCH_TECHNICIAN_LEVEL_OPTIONS_REQUEST,
                FETCH_TECHNICIAN_LEVEL_OPTIONS_SUCCESS,
                FETCH_TECHNICIAN_LEVEL_OPTIONS_ERROR,
            ],
            callAPI: () => ApiClient.get('service/TechnicianLevel/GetSelectList'),
            payload: {},
        }),
    );
};

export const createTechnicianLevel = (data, formId) => dispatch => {
    return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
        dispatch({
            types: [CREATE_TECHNICIAN_LEVEL_REQUEST, CREATE_TECHNICIAN_LEVEL_SUCCESS, CREATE_TECHNICIAN_LEVEL_ERROR],
            callAPI: () => ApiClient.post('service/TechnicianLevel/Create', data),
            payload: { data, formId },
        }),
    );
};


export const getTechnicianLevelDetail = id => dispatch => {

    return Promise.resolve().then(() =>
        dispatch({
            types: [GET_TECHNICIAN_LEVEL_DETAIL_REQUEST, GET_TECHNICIAN_LEVEL_DETAIL_SUCCESS, GET_TECHNICIAN_LEVEL_DETAIL_ERROR],
            callAPI: () => ApiClient.get(`service/TechnicianLevel/GetDetail/${id}`),
            payload: { data: { id } },
        }),
    );
};



export const deleteTechnicianLevel = id => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [DELETE_TECHNICIAN_LEVEL_REQUEST, DELETE_TECHNICIAN_LEVEL_SUCCESS, DELETE_TECHNICIAN_LEVEL_ERROR],
            callAPI: () => ApiClient.delete(`service/TechnicianLevel/${id}`),
            payload: { data: { id } },
        }),
    );
};

const initialState = {
    payload: {},
    data: {},
    response: {},
    error: {},
    errorMessage: '',
    successMessage: '',
};

export default function reducer(state = initialState, action) {
    const { payload, response, error, successMessage, errorMessage } = action;
    switch (action.type) {
        case FETCH_TECHNICIANS_REQUEST:
        case FETCH_TECHNICIAN_OPTIONS_REQUEST:
        case FETCH_TECHNICIAN_GROUP_OPTIONS_REQUEST:
        case GET_TECHNICIAN_HIERARCHY_DATA_REQUEST:
        case GET_TECHNICIAN_DETAIL_REQUEST:
        case UPDATE_TECHNICIAN_REQUEST:
        case DELETE_TECHNICIAN_REQUEST:
        case FETCH_TECHNICIAN_LEVEL_OPTIONS_REQUEST:
        case FETCH_TECHNICIAN_LEVEL_REQUEST:
        case GET_TECHNICIAN_LEVEL_DETAIL_REQUEST:
        case CREATE_TECHNICIAN_LEVEL_REQUEST:
        case DELETE_TECHNICIAN_LEVEL_REQUEST:
        case FETCH_TECHNICIAN_COMMISSION_REQUEST:
        case FETCH_TECHNICIAN_COMMISSION_HISTORY_REQUEST:
        case DELETE_TECHNICIAN_GROUP_REQUEST:
        case GET_TECHNICIAN_COMMISSION_DETAIL_REQUEST:
        case UPDATE_TECHNICIAN_COMMISSION_REQUEST:
        case GET_TECHNICIAN_LOCATION_DETAIL_REQUEST:
        case FETCH_TECHNICIAN_LEADER_OPTIONS_REQUEST:
        case UPDATE_TECHNICIAN_LOCATION_REQUEST:
            return {
                ...state,
                payload,
                response: {},
                error: {},
                successMessage: '',
                errorMessage: '',
            };

        case FETCH_TECHNICIANS_SUCCESS:
        case FETCH_TECHNICIAN_COMMISSION_SUCCESS:

            return {
                ...state,
                data: {
                    ...state.data,
                    items: response.data.data.items,
                    pages: response.data.data.pageCount,
                },
                response,
                successMessage,
            };

        case GET_TECHNICIAN_COMMISSION_DETAIL_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    itemsone: response.data.data,

                },
                response,
                successMessage,
            };

        case FETCH_TECHNICIAN_LEADER_OPTIONS_SUCCESS:
            return {
                ...state,
                data: { ...state.data, technicianLeaderOptions: response.data.data },
                response,
                successMessage,
            };

        case FETCH_TECHNICIAN_OPTIONS_SUCCESS:
            return {
                ...state,
                data: { ...state.data, technicianOptions: response.data.data },
                response,
                successMessage,
            };

        case FETCH_TECHNICIAN_GROUP_OPTIONS_SUCCESS:
            return {
                ...state,
                data: { ...state.data, technicianGroupOptions: response.data.data },
                response,
                successMessage,
            };

        case GET_TECHNICIAN_DETAIL_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    item: response.data.data,
                },
                response,
                successMessage,
            };

        case GET_TECHNICIAN_LOCATION_DETAIL_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    technicianLocationItem: response.data.data,
                },
                response,
                successMessage,
            };

        case GET_TECHNICIAN_HIERARCHY_DATA_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    hierarchyData: response.data.data,
                },
                response,
                successMessage,
            };

        case UPDATE_TECHNICIAN_COMMISSION_SUCCESS:
        case UPDATE_TECHNICIAN_SUCCESS:
        case DELETE_TECHNICIAN_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                },
                response,
                successMessage,
            };

        //TECHNICIAN LEVEL


        case FETCH_TECHNICIAN_LEVEL_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    items: response.data.data.items,
                    pages: response.data.data.pageCount,
                },
                response,
                successMessage,
            };

        case FETCH_TECHNICIAN_LEVEL_OPTIONS_SUCCESS:
            return {
                ...state,
                data: { ...state.data, technicianLeveloptions: response.data.data },
                response,
                successMessage,
            };




        case CREATE_TECHNICIAN_LEVEL_SUCCESS:

        case UPDATE_TECHNICIAN_LOCATION_SUCCESS:
        case DELETE_TECHNICIAN_LEVEL_SUCCESS:
            return {
                ...state,
                response,
                successMessage,
            };

        case GET_TECHNICIAN_LEVEL_DETAIL_SUCCESS:

            return {
                ...state,
                data: {
                    ...state.data,
                    item: response.data.data,
                },
                response,
                successMessage,
            };

        case FETCH_TECHNICIAN_LEVEL_OPTIONS_ERROR:
        case FETCH_TECHNICIAN_LEVEL_ERROR:
        case GET_TECHNICIAN_LEVEL_DETAIL_ERROR:
        case CREATE_TECHNICIAN_LEVEL_ERROR:
        case DELETE_TECHNICIAN_LEVEL_ERROR:
        //END TECHNICIAN LEVEL
        case FETCH_TECHNICIANS_ERROR:
        case FETCH_TECHNICIAN_OPTIONS_ERROR:
        case FETCH_TECHNICIAN_GROUP_OPTIONS_ERROR:
        case GET_TECHNICIAN_HIERARCHY_DATA_ERROR:
        case GET_TECHNICIAN_DETAIL_ERROR:
        case UPDATE_TECHNICIAN_ERROR:
        case DELETE_TECHNICIAN_ERROR:
        case FETCH_TECHNICIAN_COMMISSION_ERROR:
        case FETCH_TECHNICIAN_COMMISSION_HISTORY_ERROR:
        case GET_TECHNICIAN_COMMISSION_DETAIL_ERROR:
        case DELETE_TECHNICIAN_GROUP_SUCCESS:
        case GET_TECHNICIAN_LOCATION_DETAIL_ERROR:
        case UPDATE_TECHNICIAN_LOCATION_ERROR:
        case UPDATE_TECHNICIAN_COMMISSION_ERROR:
            return {
                ...state,
                payload,
                error,
                errorMessage,
            };
        default:
            return state;
    }
}
